import { render, staticRenderFns } from "./ComplaintManageNullTracking.vue?vue&type=template&id=617d22b2&"
import script from "./ComplaintManageNullTracking.vue?vue&type=script&lang=js&"
export * from "./ComplaintManageNullTracking.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintManageNullTracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports